// extracted by mini-css-extract-plugin
export default {"header":"Header_header__EsTli","intersecting":"Header_intersecting__eH62D","heading":"Header_heading__XEtES","logo":"Header_logo__Gz424"};